import { render, staticRenderFns } from "./decsDetail.vue?vue&type=template&id=86fa9e0a&scoped=true"
import script from "./decsDetail.vue?vue&type=script&lang=js"
export * from "./decsDetail.vue?vue&type=script&lang=js"
import style0 from "./decsDetail.vue?vue&type=style&index=0&id=86fa9e0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fa9e0a",
  null
  
)

export default component.exports